export const DUTCH_CANCEL_SUBSCRIPTION_LABEL = 'Abonnement opzeggen'

/** Live page slug keeps the double b; the single-b URL 404s. */
export const DUTCH_CANCEL_SUBSCRIPTION_PATH = '/opzeggen-abbonement/'
